/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useAdminJiraTicketsPageStyles = makeStyles(theme => ({
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  newIssueButton: {
    width: '15%',
    height: '80%',
  },
  typeSelect: {
    width: '20%',
    alignSelf: 'baseline',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    gridGap: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    color: theme.palette.scalefieldTextPrimary.main,
    fontSize: '32px',
    lineHeight: '38px',
    fontWeight: 'bold',
  },
}));
